<template>
  <div>
    <ul-nav  v-if="this.batch_id != null" :batch_id="batch_id"/>
    <div class="container-fluid" style="height: 1000px">
     <!-- Office matching with suggestions -->
      <div
        class="row"
        v-if="this.table == 'ultralocal.ul_office_matching_selection'"
      >
        <h2 class="table-name" style="margin-bottom: 0">
          Ultralocal Office Matching
        </h2>
        <div
          class="btn-group text-center"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <button
            class="btn btn-primary btn-hide"
            style="width: 150px"
            v-if="!showSearch"
            v-on:click="toggleSearch"
          >
            <i class="fa fa-search" style="font-size: 16px"></i>
            Search
            <span v-if="activeQuery && !searchError" class="badge">Active</span>
            <span v-if="activeQuery && searchError" class="badge badge-error"
              >Error</span
            >
          </button>
          <button
            class="btn btn-default btn-hide"
            style="width: 80px"
            v-if="showSearch"
            v-on:click="toggleSearch"
          >
            Hide
          </button>
        </div>
        <button
          class="btn btn-primary btn-hide"
          style="width: 150px"
          v-if="!showSearch && !showExpand"
          @click="collapseAll"
        >
          <i class="fa fa-angle-double-down" style="font-size: 16px"></i>
          Collapse All
        </button>
        <button
          class="btn btn-primary btn-hide"
          style="width: 150px"
          v-if="!showSearch && showExpand"
          @click="expandAll"
        >
          <i class="fa fa-expand" style="font-size: 16px"></i> Expand All
        </button>
        <button
          class="btn btn-primary btn-hide"
          style="width: 150px"
          v-if="!showSearch && showSelectAll && !showExpand"
          @click="selectAll"
        >
          <i class="fa fa-check" style="font-size: 16px"></i> Select All
        </button>

        <div v-if="showSearch">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-on:change="depthLevel" />
              Complex Search
            </label>
          </div>
          <vue-query-builder
            :rules="rules"
            :maxDepth="depth"
            :labels="labels"
            :styled="true"
            v-model="query"
          ></vue-query-builder>

          <div style="display: block; margin-top: 20px">
            <div class="btn-group text-center">
              <button
                class="btn btn-default btn-hide btn-share"
                v-on:click="doFormatUrl"
              >
                Share Url
              </button>
              <button
                class="btn btn-primary btn-hide btn-search"
                v-on:click="doSearch"
              >
                Search
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <hr />
        </div>
        <div v-if="!searchError" class="search-options">
          <div style="display: inline">
            <label for="pageSelect" style="margin-bottom: 15px"
              >Records per page</label
            >
            <select
              class="form-control record-number"
              :value="limit"
              id="pageSelect"
              v-on:change="changeLimit"
            >
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
              <option>500</option>
            </select>
          </div>
          <div style="display: inline">
            <label for="pageNum" style="display: inline">Page Number</label>
            <input
              type="number"
              :value="offset"
              min="1"
              v-on:change="changePage"
              class="form-control page-select"
              placeholder="Page #"
              id="pageNum"
            />
          </div>

          <div style="display: inline">
            <label for="orderBy" style="margin-bottom: 15px">Sort Column</label>
            <select
              v-on:change="setOrderBy"
              v-model="orderBy"
              class="form-control orderBy"
              id="orderBy"
            >
              <option v-for="col in orderByFilters" :value="col.value">
                {{ col.label }}
              </option>
            </select>
          </div>
          <div style="display: inline">
            <label for="sortDirection" style="margin-bottom: 15px"
              >Sort Direction</label
            >
            <select
              v-on:change="setSortDirection"
              v-model="sortDirection"
              class="form-control sortBy"
              id="sortDirection"
            >
              <option :value="''">None</option>
              <option :value="'desc'">Descending</option>
              <option :value="'asc'">Ascending</option>
            </select>
          </div>
          <div v-if="loading" class="fa-3x text-center">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
        </div>

        <hot-table
          class="ulhandsontable"
          :data="matchdata"
          :settings="settings"
          ref="ulhot"
        >
        </hot-table>
      </div>
       <!-- Office matching with dropdown values 1 -table  -->
       <div
        class="row"
        v-if="this.table == 'ultralocal.ul_office_matching_dropdown' || this.table == 'ultralocal.ul_offices_creation_dropdown'"
      >
       <h2 class="table-name" style="margin-bottom: 0">
        {{this.table === "ultralocal.ul_office_matching_dropdown"
      ? "Ultralocal Office Matching with Dropdown"
      : this.table === "ultralocal.ul_office_creation_dropdown"
      ? "Ultralocal Office Creation with Dropdwn"
      : ""
       }}
          
        </h2>
        <p
            v-if="this.table == 'ultralocal.ul_offices_creation_dropdown'"
            style="color: #bc243c; width: 75%; padding-top: 5px"
          >
            <b
              ><i>{{ pageDisclaimer }}</i></b
            >
          </p>
        <div
          class="btn-group text-center"
          style="margin-top: 10px; margin-bottom: 10px"
        >
          <button
            class="btn btn-primary btn-hide"
            style="width: 150px"
            v-if="!showSearch"
            v-on:click="toggleSearch"
          >
            <i class="fa fa-search" style="font-size: 16px"></i>
            Search
            <span v-if="activeQuery && !searchError" class="badge">Active</span>
            <span v-if="activeQuery && searchError" class="badge badge-error"
              >Error</span
            >
          </button>
          <button
            class="btn btn-default btn-hide"
            style="width: 80px"
            v-if="showSearch"
            v-on:click="toggleSearch"
          >
            Hide
          </button>
        </div>
         <button
              class="btn btn-primary btn-hide"
              style="width: 150px"
              v-if="
                !showSearch &&
                this.table == 'ultralocal.ul_offices_creation_workflow' || this.table == 'ultralocal.ul_offices_creation_dropdown'
              "
              v-on:click="createOffices"
            >
              <i
                class="fa fa-plus"
                aria-hidden="true"
                style="font-size: 16px"
              ></i>
              Create
            </button>
        <div v-if="showSearch">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-on:change="depthLevel" />
              Complex Search
            </label>
          </div>
          <vue-query-builder
            :rules="rules"
            :maxDepth="depth"
            :labels="labels"
            :styled="true"
            v-model="query"
          ></vue-query-builder>

          <div style="display: block; margin-top: 20px">
            <div class="btn-group text-center">
              <button
                class="btn btn-default btn-hide btn-share"
                v-on:click="doFormatUrl"
              >
                Share Url
              </button>
              <button
                class="btn btn-primary btn-hide btn-search"
                v-on:click="doSearch"
              >
                Search
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <hr />
        </div>
        <div v-if="!searchError" class="search-options">
          <div style="display: inline">
            <label for="pageSelect" style="margin-bottom: 15px"
              >Records per page</label
            >
            <select
              class="form-control record-number"
              :value="limit"
              id="pageSelect"
              v-on:change="changeLimit"
            >
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
              <option>500</option>
            </select>
          </div>
          <div style="display: inline">
            <label for="pageNum" style="display: inline">Page Number</label>
            <input
              type="number"
              :value="offset"
              min="1"
              v-on:change="changePage"
              class="form-control page-select"
              placeholder="Page #"
              id="pageNum"
            />
          </div>

          <div style="display: inline">
            <label for="orderBy" style="margin-bottom: 15px">Sort Column</label>
            <select
              v-on:change="setOrderBy"
              v-model="orderBy"
              class="form-control orderBy"
              id="orderBy"
            >
              <option v-for="col in orderByFilters" :value="col.value">
                {{ col.label }}
              </option>
            </select>
          </div>
          <div style="display: inline">
            <label for="sortDirection" style="margin-bottom: 15px"
              >Sort Direction</label
            >
            <select
              v-on:change="setSortDirection"
              v-model="sortDirection"
              class="form-control sortBy"
              id="sortDirection"
            >
              <option :value="''">None</option>
              <option :value="'desc'">Descending</option>
              <option :value="'asc'">Ascending</option>
            </select>
          </div>
          <div v-if="loading" class="fa-3x text-center">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
        </div>

        <hot-table
          class="ulhandsontable"
          :data="matchdata"
          :settings="settings"
          :columns="columnMetaData"
          ref="ulhot"
        >
        </hot-table>
      </div>
      <!-- Office matching with matching or office creation side by side tables -->
      <div
        class="row"
        v-if="
          this.table == 'ultralocal.ul_office_matching' ||
          this.table == 'ultralocal.ul_offices_creation_workflow'
        "
      >
        <div :class="[this.table.replace('ultralocal.', '')]">
          <h2
            v-if="this.table == 'ultralocal.ul_office_matching'"
            class="table-name"
            style="margin-bottom: 0"
          >
            Offices to Match
          </h2>

          <p
            v-if="this.table == 'ultralocal.ul_office_matching'"
            style="color: #bc243c; width: 75%; padding-top: 5px"
          >
            <b
              ><i>{{ pageDisclaimer }}</i></b
            >
          </p>
          <h2
            v-if="this.table == 'ultralocal.ul_offices_creation_workflow'"
            class="table-name"
            style="margin-bottom: 0"
          >
            Offices to Create
          </h2>
          <p
            v-if="this.table == 'ultralocal.ul_offices_creation_workflow' "
            style="color: #bc243c; width: 75%; padding-top: 5px"
          >
            <b
              ><i>{{ pageDisclaimer }}</i></b
            >
          </p>
          <div
            class="btn-group text-center"
            style="margin-top: 10px; margin-bottom: 10px"
          >
            <button
              class="btn btn-primary btn-hide"
              style="width: 150px"
              v-if="!showSearch"
              v-on:click="toggleSearch"
            >
              <i class="fa fa-search" style="font-size: 16px"></i>
              Search
              <span v-if="activeQuery && !searchError" class="badge"
                >Active</span
              >
              <span v-if="activeQuery && searchError" class="badge badge-error"
                >Error</span
              >
            </button>
            <button
              class="btn btn-primary btn-hide"
              style="width: 150px"
              v-if="
                !showSearch &&
                this.table == 'ultralocal.ul_offices_creation_workflow' || this.table == 'ultralocal.ul_offices_creation_dropdown'
              "
              v-on:click="createOffices"
            >
              <i
                class="fa fa-plus"
                aria-hidden="true"
                style="font-size: 16px"
              ></i>
              Create
            </button>
            <button
              class="btn btn-default btn-hide"
              style="width: 80px"
              v-if="showSearch"
              v-on:click="toggleSearch"
            >
              Hide
            </button>
          </div>

          <div v-if="showSearch">
            <div class="checkbox">
              <label>
                <input type="checkbox" v-on:change="depthLevel" />
                Complex Search
              </label>
            </div>
            <vue-query-builder
              :rules="rules"
              :maxDepth="depth"
              :labels="labels"
              :styled="true"
              v-model="query"
            ></vue-query-builder>

            <div style="display: block; margin-top: 20px">
              <div class="btn-group text-center">
                <button
                  class="btn btn-default btn-hide btn-share"
                  v-on:click="doFormatUrl"
                >
                  Share Url
                </button>
                <button
                  class="btn btn-primary btn-hide btn-search"
                  v-on:click="doSearch"
                >
                  Search
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <hr />
          </div>
          <div v-if="!searchError" class="search-options">
            <div style="display: inline">
              <label for="pageSelect" style="margin-bottom: 15px"
                >Records per page</label
              >
              <select
                class="form-control record-number"
                :value="limit"
                id="pageSelect"
                v-on:change="changeLimit"
              >
                <option>25</option>
                <option>50</option>
                <option>100</option>
                <option>250</option>
                <option>500</option>
              </select>
            </div>
            <div style="display: inline">
              <label for="pageNum" style="display: inline">Page Number</label>
              <input
                type="number"
                :value="offset"
                min="1"
                v-on:change="changePage"
                class="form-control page-select"
                placeholder="Page #"
                id="pageNum"
              />
            </div>

            <div style="display: inline">
              <label for="orderBy" style="margin-bottom: 15px"
                >Sort Column</label
              >
              <select
                v-on:change="setOrderBy"
                v-model="orderBy"
                class="form-control orderBy"
                id="orderBy"
              >
                <option v-for="col in orderByFilters" :value="col.value">
                  {{ col.label }}
                </option>
              </select>
            </div>
            <div style="display: inline">
              <label for="sortDirection" style="margin-bottom: 15px"
                >Sort Direction</label
              >
              <select
                v-on:change="setSortDirection"
                v-model="sortDirection"
                class="form-control sortBy"
                id="sortDirection"
              >
                <option :value="''">None</option>
                <option :value="'desc'">Descending</option>
                <option :value="'asc'">Ascending</option>
              </select>
            </div>
            <div v-if="loading" class="fa-3x text-center">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
          </div>
          <div max-width="60px">
            <hot-table
              class="ulhandsontable_small"
              :data="matchdata"
              :settings="settings"
              :columns="columnMetaData"
              ref="ulhot"
            >
            </hot-table>
          </div>
        </div>
        <div
          :class="
            this.table == 'ultralocal.ul_office_matching'
              ? 'offices_for_matching'
              : 'districts_for_matching'
          "
        >
          <h2
            v-if="this.table == 'ultralocal.ul_office_matching'"
            class="table-name"
            style="margin-bottom: 0"
          >
            Offices Table
          </h2>
          <h2
            v-if="this.table == 'ultralocal.ul_offices_creation_workflow'"
            class="table-name"
            style="margin-bottom: 0"
          >
            Districts Table
          </h2>
          <br><br><br>
          <div
            class="btn-group text-center"
            style="margin-top: 10px; margin-bottom: 10px"
          >
            <button
              class="btn btn-primary btn-hide"
              style="width: 150px"
              v-if="!showSearch2"
              v-on:click="toggleSearch2"
            >
              <i class="fa fa-search" style="font-size: 16px"></i>
              Search
              <span v-if="activeQuery2 && !searchError2" class="badge"
                >Active</span
              >
              <span
                v-if="activeQuery2 && searchError2"
                class="badge badge-error"
                >Error</span
              >
            </button>
            <button
              class="btn btn-default btn-hide"
              style="width: 80px"
              v-if="showSearch2"
              v-on:click="toggleSearch2"
            >
              Hide
            </button>
          </div>
          <div v-if="showSearch2">
            <div class="checkbox">
              <label>
                <input type="checkbox" v-on:change="depthLevel2" />
                Complex Search
              </label>
            </div>
            <vue-query-builder
              :rules="rules2"
              :maxDepth="depth2"
              :labels="labels"
              :styled="true"
              v-model="query2"
            ></vue-query-builder>

            <div style="display: block; margin-top: 20px">
              <div class="btn-group text-center">
                <button
                  class="btn btn-primary btn-hide btn-search"
                  v-on:click="doSearch2"
                >
                  Search
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <hr />
          </div>
          <div v-if="!searchError2" class="search-options">
            <div style="display: inline">
              <label for="pageSelect2" style="margin-bottom: 15px"
                >Records per page</label
              >
              <select
                class="form-control record-number"
                :value="limit2"
                id="pageSelect2"
                v-on:change="changeLimit2"
              >
                <option>25</option>
                <option>50</option>
                <option>100</option>
                <option>250</option>
                <option>500</option>
              </select>
            </div>
            <div style="display: inline">
              <label for="pageNum2" style="display: inline">Page Number</label>
              <input
                type="number"
                :value="offset2"
                min="1"
                v-on:change="changePage2"
                class="form-control page-select"
                placeholder="Page #"
                id="pageNum2"
              />
            </div>

            <div style="display: inline">
              <label for="orderBy2" style="margin-bottom: 15px"
                >Sort Column</label
              >
              <select
                v-on:change="setOrderBy2"
                v-model="orderBy2"
                class="form-control orderBy"
                id="orderBy2"
              >
                <option v-for="col in orderByFilters2" :value="col.value">
                  {{ col.label }}
                </option>
              </select>
            </div>
            <div style="display: inline">
              <label for="sortDirection" style="margin-bottom: 15px"
                >Sort Direction</label
              >
              <select
                v-on:change="setSortDirection2"
                v-model="sortDirection2"
                class="form-control sortBy"
                id="sortDirection"
              >
                <option :value="''">None</option>
                <option :value="'desc'">Descending</option>
                <option :value="'asc'">Ascending</option>
              </select>
            </div>
            <div v-if="loading2" class="fa-3x text-center">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
          </div>

          <hot-table
            class="ulhandsontable_small"
            :data="office_district_data"
            :settings="settingsTwo"
            :columns="columnMetaData2"
            ref="ulhot2"
          >
          </hot-table>
        </div>
      </div>
    </div>
  </div>
</template>
 
 

<script>
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.css";
import VueQueryBuilder from "vue-query-builder";
import getFiltersForSearch from "../mixins/filtersForSearch.js";
import getOrderByFilters from "../mixins/getOrderByFilters.js";
import getColumnMetaData from "../mixins/columnMetaData.js";
//import getTablePermissions from "../mixins/getTablePermissions.js";
import getPageDisclaimer from "../mixins/pageDisclaimers.js";
import { registerAllModules } from 'handsontable/registry';
import ULNavHeader from "../components/shared/ULNavHeader";

registerAllModules();

export default {
  name: "ULOfficeMatching",
  components: {
    HotTable,
    VueQueryBuilder,
    "ul-nav": ULNavHeader
  },
  mixins: [
    getOrderByFilters,
    getFiltersForSearch,
    getColumnMetaData,
    //getTablePermissions,
    getPageDisclaimer,
  ],
  data: function () {
    return {
      matchdata: [{}],
      columnMetaData: [],
      columnMetaData2: [],
      office_district_data: [],
      //permissions: this.getTablePermissions(this.$route.params.table),
      showSearch: false,
      activeQuery: false,
      showSearch2: false,
      activeQuery2: false,
      searchError: false,
      searchError2: false,
      showExpand: false,
      showSelectAll: false,
      depth: 1,
      limit: 25,
      offset: 1,
      depth2: 1,
      limit2: 25,
      offset2: 1,
      batch_id:null,
      pageDisclaimer: null,
      sortDirection: " ",
      sortDirection2: " ",
      loading: false,
      loading2: false,
      submitCreateClicked: false,
      workingOnSubmittedData: false,
      orderBy: "contest",
      orderBy2: null, //this.table == "ultralocal.ul_office_matching" ? "office" : "district",
      orderByFilters: [],
      orderByFilters2: [],
      rules: [],
      rules2: [],
      table: this.$route.params.table,
      table_update: "ultralocal.ul_office_matching",
      dataListCol: null,
      sourceCol:null,
      labels: {
        matchType: "Match Type",
        matchTypes: [
          { id: "all", label: "All of the filters" },
          { id: "any", label: "Any of the filters" },
        ],
        addRule: "Add Filter",
      },
      query: null,
      query2: null,
      table_hold: null,
      settingsTwo: {
        startRows: 1,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 500,
        comments: true
       },
      settings: {
        startRows: 1,
        rowHeaders:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? true
            : false,
        nestedRows:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? true
            : false,

        colHeaders:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? [
                "# Suggestions",
                "State",
                "County",
                "Contest",
                "BP Office Name",
                "BP Office ID",
                "BP District Type",
                "BP District State",
                "Selected",
                "Parent",
                "Created",
              ]
            : [],

        bindRowsWithHeaders: false,
        renderAllColumns: true,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 1010,
        undo: true,
        comments: true,
        hiddenColumns: this.$route.params.table == "ultralocal.ul_office_matching_dropdown"  ? {columns: [7], indicators: false} : (this.$route.params.table == "ultralocal.ul_offices_creation_dropdown"  ? {columns: [9], indicators: false} : {}),
     

       
        cells:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? function (row, col) {
                var cellProperties = {};

                if (col != 8) {
                  cellProperties.readOnly = true;
                } else {
                  cellProperties.renderer = "checkbox";

                  //cellProperties.readOnly = this.checkReadOnly(row);
                }

                return cellProperties;
              }
            :  null,
        afterChange: (changes) => {
          
          if (changes) {
             this.doChanges(changes);
          }
        },
        beforeUndo: async (action) => {
          let changes = action.changes;
          for await (const change of changes) {
            let cellMeta = this.$refs.ulhot.hotInstance.getCellMetaAtRow(
              change[0]
            );
            let colToChange = this.$refs.ulhot.hotInstance.colToProp(change[1]);
            let col = cellMeta.filter((obj) => {
              if (
                obj.__proto__.readOnly === false &&
                obj.__proto__.data === colToChange
              ) {
                return obj;
              }
            });
            if (col.length > 0 && change[2] != "" && change[2] != null) {
              // related table need to lookup value
              if (
                this.$refs.ulhot.hotInstance.getCellMeta(change[0], col[0].col)
                  .__proto__.relatedTable
              ) {
                let relatedTable = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.relatedTable;
                let colToUpdate = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.colToUpdate;
                let colToRender = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.colToRender;
               

                let response = await this.getRelatedData(
                  relatedTable,
                  change[2]
                );

                let responseField = colToRender.replace(`${colToUpdate}.`, "");
                let stringToRender = this.buildStringToRender(
                  response,
                  responseField
                );
                this.$refs.ulhot.hotInstance.setCellMeta(
                  change[0],
                  col[0].col,
                  "valueToRender",
                  stringToRender.slice(0, -1)
                );
                this.$refs.ulhot.hotInstance.render();
              }
            }
            if (col.length > 0 && (change[2] === "" || change[2] == null)) {
              this.$refs.ulhot.hotInstance.setCellMeta(
                change[0],
                col[0].col,
                "valueToRender",
                null
              );
              this.$refs.ulhot.hotInstance.render();
            }
          }
        },

        beforeKeyDown: (event) => {
          this.doBeforeKeyDown(event);
        },
       // beforePaste: (data, coords) => {
          //this.doBeforePaste(data, coords);
       // },
       afterOnCellMouseDown: async (e, coords, td) => {
          if (coords.row < 0){
            coords.row = 0;
          }
           
           let columnMetaData = this.$refs.ulhot.hotInstance.getCellMeta(coords.row, coords.col).__proto__;
           if (columnMetaData.renderer === 'autocomplete'){
              await this.populateAutocomplete(columnMetaData,coords);
           }
           
          
        },

        afterPaste: async (data, coords) => {
          await this.doAfterPaste(data, coords);
        },
        beforeAutofill:   (selectionData, sourceRange, targetRange, direction) => {
             
          let rowCounter = -1;
          let colToRender;
          let colCounter = -1;
          let source_range_row = sourceRange.from.row -1;
         
          for  (let i = targetRange.from.row; i <= targetRange.to.row; i++) {
            source_range_row++;
            if (source_range_row > sourceRange.to.row){
              source_range_row = sourceRange.from.row

            }
            rowCounter++;
            rowCounter = rowCounter > selectionData.length -1 ? 0 : rowCounter;

            for (let j = targetRange.from.col; j <= targetRange.to.col; j++) {
              colCounter++;
              colCounter = colCounter > selectionData[0].length -1 ? 0 : colCounter;
              
              if (this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__.relatedTable) {
                              
              let this_value = this.$refs.ulhot.hotInstance.getCell(source_range_row , j).innerHTML 
              if (this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__.renderer === "relatedTableRenderer") {
                  this.$refs.ulhot.hotInstance.setCellMeta(i,j, 'valueToRender', this_value);
                  this.$refs.ulhot.hotInstance.render();
              }
             }

            }

          }
    
               return selectionData ;
  
         },
      },
    };
  },

  methods: {
    async populateAutocomplete(cellMeta,coords) {
     let hasNeededList = this.$refs.ulhot.hotInstance.getDataAtCell(coords.row, this.dataListCol);
     let county_col = this.$refs.ulhot.hotInstance.propToCol('county');
     let state_col = this.$refs.ulhot.hotInstance.propToCol('state');
    
     if (state_col =='state') {
           state_col = this.$refs.ulhot.hotInstance.propToCol('contest_state');
    }

  if(hasNeededList == null){
    for (let rowIndex = 0; rowIndex < this.$refs.ulhot.hotInstance.countRows(); rowIndex++) {
      let loop_coords = { row: rowIndex, col: coords.col};
      let stateData = this.$refs.ulhot.hotInstance.getDataAtCell(loop_coords.row, state_col);
      let countyData = this.$refs.ulhot.hotInstance.getDataAtCell(loop_coords.row,county_col);
      let params = { "state": stateData, "county": countyData};
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      if (this.table == "ultralocal.ul_office_matching_dropdown"){
            headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/import_engine/matching_offices`;
      } else if (this.table == "ultralocal.ul_offices_creation_dropdown"){
            
            headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/import_engine/matching_districts`;
      }
     

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(params),
        }
      );
       
      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        //window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
       
        if (response.success === true) {
          var returned_ids = [];
          var returned_names = [];
          for (let i = 0; i < response.data.length; i++)
          {
            let entity = response.data[i]
            returned_ids.push({_id: Number(entity.id), label: entity.name});
            returned_names.push(entity.name);
            let entity_id = entity.id;
             }

          //update cell properties to set data to this list, add to hidden column  so we don't re-fetch later
         
          this.$refs.ulhot.hotInstance.setDataAtCell(loop_coords.row, this.dataListCol,  returned_ids);
          this.$refs.ulhot.hotInstance.setCellMeta(loop_coords.row, loop_coords.col, 'source', returned_names);
        } else if (response.success === false) {
          this.statsError = true;
        }
        
      }
    }
    this.$refs.ulhot.hotInstance.render();
    return;
  }

    } , 
    async getFilteredData() {
    
      this.loading = true;

      let query = {};

      query.where = this.query;
      query.table =  this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy
        ? `${this.orderBy} ${this.sortDirection}`
        : null;

      query.isCountOnly = false;
      if (query.where && query.where.children) {
        this.activeQuery = true;
        // If user removes search criteria, null the WHERE clause.
        if (query.where.children.length === 0) {
          query.where = null;
          this.activeQuery = false;
        }
      }
      if(this.batch_id != null){
        if (query.where === null)
        {
          query.where = {logicalOperator: "all",
            children: []
          }
        }
        if (query.where.children &&   (query.where.children).some(item => item.query.rule === 'named_bfed_batch')){
            //empty
        } else {
          query.where.children.push(
              // Build the query like the queryBuilder does it to pass to backend.
              {
                type: "query-builder-rule",
                query: {
                  rule: "named_bfed_batch",
                  selectedOperator: this.table == "ultralocal.ul_office_matching_selection" || this.table == "ultralocal.ul_offices_creation_workflow" || this.table == "ultralocal.ul_offices_creation_dropdown"
                   ? "equal"
                   : "array_contains",
                  selectedOperand: "named_bfed_batch",
                  value: this.batch_id
                }
              }
            );
       }
      }

      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(query),
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
        if (response.success === true) {
          // Clear current table data.
          //set ui to expand

          //this.matchdata = [];
          this.matchdata.length = 0;
          if (this.table == "ultralocal.ul_office_matching_selection") {
              this.$refs.ulhot.hotInstance
              .getPlugin("nestedRows")
              //.collapsingUI.expandAll();
          }

         // await this.$refs.ulhot.hotInstance.loadData(this.matchdata);

          let i = 0;
          await response.data.forEach((item) => {
            i++;
            if (this.table == "ultralocal.ul_office_matching_selection") {
              this.matchdata.push(item["info"]);
            } else {
              this.matchdata.push(item);
            }
          });
          this.searchError = false;
          if (this.matchdata.length == 0){
            this.matchdata = [{}];
          }
          await this.$refs.ulhot.hotInstance.loadData(this.matchdata);
        } else if (response.success === false) {
          this.searchError = true;
        }
        this.loading = false;
        this.showExpand = false;
        // if all the records have 1 suggestion we show select all
        // this.showSelectAll = this.allEqual(
        //   this.$refs.ulhot.hotInstance.getDataAtCol(
        //     this.$refs.ulhot.hotInstance.propToCol("number_of_suggestions")
        //   )
        // );
        const columnIndex = this.$refs.ulhot.hotInstance.propToCol("number_of_suggestions");
        const sourceData = this.$refs.ulhot.hotInstance.getSourceData();
        const suggestionsData = sourceData.map(row => row['number_of_suggestions']) // Get values from the specified column
                                              .filter(value => value !== undefined && value !== null); // Filter out undefined or null values
        this.showSelectAll = this.allEqual(suggestionsData);
        
      }
      if (this.$route.params.table == "ultralocal.ul_office_matching_dropdown" || this.$route.params.table == "ultralocal.ul_offices_creation_dropdown")
      {
        for (var i = 0; i <= this.$refs.ulhot.hotInstance.countRows(); i++)
        { 
          var cellProperties = {};

          for (var j = 0; j < this.$refs.ulhot.hotInstance.countCols(); j++)
          {
            if (j == this.sourceCol) {
             
                //let cellValue = this.$refs.ulhot.hotInstance.getDataAtCell(i, j);
                //let cellLabel = this.$refs.ulhot.hotInstance.getCell(i, j).innerHTML;
              
              this.$refs.ulhot.hotInstance.setCellMeta(i, j, 'type', 'autocomplete');
              this.$refs.ulhot.hotInstance.setCellMeta(i, j, 'trimDropdown', false);
              this.$refs.ulhot.hotInstance.setCellMeta(i, j, 'source', '');
              
            }
          }
         }
        //return cellProperties;
      }
      
    },
    async getFilteredData2() {
      this.loading2 = true;

      let query = {};

      query.where = this.query2;

      query.table =
        this.table == "ultralocal.ul_office_matching"
          ? "ultralocal.offices_for_matching"
          : "ultralocal.districts_for_matching";
      query.limit = this.limit2;
      query.offset = this.offset2;
      query.orderBy = this.orderBy2
        ? `${this.orderBy2} ${this.sortDirection2}`
        : null;

      query.isCountOnly = false;
      if (query.where && query.where.children) {
        this.activeQuery2 = true;
        // If user removes search criteria, null the WHERE clause.
        if (query.where.children.length === 0) {
          query.where = null;
          this.activeQuery2 = false;
        }
      }
     
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(query),
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
        if (response.success === true) {
          // Clear current table data.
          this.office_district_data = [];

          await this.$refs.ulhot2.hotInstance.loadData(
            this.office_district_data
          );

          let i = 0;
          await response.data.forEach((item) => {
            i++;
           
            this.office_district_data.push(item);
          });
          this.searchError2 = false;
          await this.$refs.ulhot2.hotInstance.loadData(
            this.office_district_data
          );
        } else if (response.success === false) {
          this.searchError2 = true;
        }
        this.loading2 = false;
      }
    },
    async refreshHoTData() {
      if (window.location.href.indexOf("where") > -1) {
        this.loading = true;
        let query = JSON.parse(
          JSON.stringify(
            decodeURIComponent(
              window.location.href
                ? window.location.href.split("?")[1]
                : window.location.search.slice(1)
            )
          )
        );
        this.query = JSON.parse(query).where;
        this.limit = JSON.parse(query).limit;
        this.offset = JSON.parse(query).offset;

        this.showSearch = true;
        this.getFilteredData();

        this.loading = false;
      }
      // Else populate table with most recent updated records for table
        this.getFilteredData();
    },
   
    async doAfterPaste(data, coords) {
      // if this related table field we need to get the related display information from the database
      //let rowCounter = coords[0].startRow - 1;
      let dataRowCounter = -1;
      let dataColCounter = -1;
      
      for (let i = coords[0].startRow; i <= coords[0].endRow; i++) {
        
        //rowCounter++;
        dataColCounter = -1;
        dataRowCounter++;
        for (let j = coords[0].startCol; j <= coords[0].endCol; j++) {
            dataColCounter++;
          if (
            this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
              .relatedTable
          ) {
            let relatedTable = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.relatedTable;
           
            let colToUpdate = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToUpdate;
           
            let colToRender = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToRender;

            //let response = await this.getRelatedData(relatedTable,Number(data[dataRowCounter][dataColCounter]));
            if (isNaN(Number(data[dataRowCounter][dataColCounter]))) {
              return;
            }
            let response = await this.getRelatedData(
              relatedTable,
              data[dataRowCounter][dataColCounter]
            );
            let responseField = colToRender.replace(`${colToUpdate}.`, "");
            let stringToRender = this.buildStringToRender(
              response,
              responseField
            );
            if (
              this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
                .renderer === "relatedTableRenderer"
            ) {
              this.$refs.ulhot.hotInstance.setCellMeta(
                i,
                j,
                "valueToRender",
                stringToRender.slice(0, -1)
              );
              this.$refs.ulhot.hotInstance.render();
            }
          }
        }
      }
    },
    async collapseRows() {
      this.$refs.ulhot.hotInstance
        .getPlugin("nestedRows")
        .collapsingUI.collapseAll();
      this.showExpand = true;
    },
    async expandAll() {
      this.$refs.ulhot.hotInstance
        .getPlugin("nestedRows")
        .collapsingUI.expandAll();
      this.showExpand = false;
     
    },
    // here I am testing that all of the values in the array = 1
    // if they are, we show the Select All button
    allEqual(myArray) {
      if (myArray[0] && myArray[0] == 1) {
        return new Set(myArray).size === 1;
      } else {
        return false;
      }
    },
    //If selectall is clicked, loop through and set the select property to true
    async selectAll() {
      let array = this.$refs.ulhot.hotInstance.getData();

      for (let i = 0; i < array.length; i++) {
        this.$refs.ulhot.hotInstance.setDataAtCell(
          i,
          this.$refs.ulhot.hotInstance.propToCol("Select"),
          true
        );
      }
    },
    async doChanges(changes) {
      
      if (this.table == "ultralocal.ul_office_matching_selection" ) {
        await this.doChangesSelection(changes);
      } else if (this.table == "ultralocal.ul_office_matching_dropdown" || this.table == 'ultralocal.ul_office_matching' || this.table == "ultralocal.ul_offices_creation_dropdown")  {
        await this.doChangesMatching(changes);
      }
    },

    async doChangesSelection(changes) {
      
      for (const change of changes) {
        let row = change[0];
        let column = this.$refs.ulhot.hotInstance.propToCol(change[1]);
        if (this.$refs.ulhot.hotInstance.getCellMeta(row, column).comment) {
          this.clearErrorValue(row, column);
          continue;
        }
         
        let select = this.$refs.ulhot.hotInstance.getDataAtRowProp(
          change[0],
          "Select"
        );
        let record_id = this.$refs.ulhot.hotInstance.getDataAtRowProp(
          change[0],
          "Parent"
        );

        let office;
        let isValid = true;
        if (
          select == true &&
          this.$refs.ulhot.hotInstance.getDataAtCell(row, 1) == null &&
          !this.showSelectAll
        ) {
          isValid = this.validateSelection(row);
          
        }
        if (isValid) {
          if (select == true || select == 'true') {
            office = this.$refs.ulhot.hotInstance.getDataAtRowProp(
              change[0],
              "bp_office_id"
            );
          } else {
            office = null;
          }
          if (record_id == null) {
            continue;
          }
          let dataObject = {};
          let payload;
          dataObject.id = Number(record_id);
          dataObject["bp_office_id"] = office;
          payload = {
            data: [dataObject],
            table: this.table_update,
          };
           
          let response = await this.submitPayload(payload);
           
          let sentence;
          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            if (response.success === false) {
               continue;
            } else {
              //this.showChangeNotification(id, columnName, currentValue, updatedValue);
              this.updateParentSelect(row, select);
              sentence = `<b>${record_id}:</b> <i>'bp_office_id'</i> changed to ${office}`;
            }

            // For Growl Notifications, but only show if edit history box is hidden.

            this.$toastr.s(sentence);
          }
        } else {
          
          change[3] = change[2]; // this prevents the id being updated with the superfluos selection
          let message = "only one field can be checked per parent";
          this.updateErrorValue(row, column, message);
        }
      }
    },
    clearErrorValue(row, column) {
      const commentsPlugin = this.$refs.ulhot.hotInstance.getPlugin("comments");
      let comment = commentsPlugin.getCommentAtCell(row, column);
      if (comment) {
        commentsPlugin.removeCommentAtCell(row, column);
        this.$refs.ulhot.hotInstance.setCellMeta(row, column, "valid", true);
        this.$refs.ulhot.hotInstance.render();
      }
    },
    updateErrorValue(row, column, message) {
      const commentsPlugin = this.$refs.ulhot.hotInstance.getPlugin("comments");
      commentsPlugin.setCommentAtCell(row, column, message);
      this.$refs.ulhot.hotInstance.setCellMeta(row, column, "valid", false);
      this.$refs.ulhot.hotInstance.render();
    },

    async doChangesMatching(changes) {
      //console.log("doChangesMatching called with changes:", `${JSON.stringify(changes)}`);     
      let payload;
     
      for (const change of changes) {
         if ((this.table === "ultralocal.ul_offices_creation_dropdown") && (change[1] == 'office_creation_district.id') && (change[3] == null || change[3] == "")) {
              //console.log("District ID change detected, clearing source value");
              this.$refs.ulhot.hotInstance.setDataAtCell(change[0],this.$refs.ulhot.hotInstance.propToCol('source'), null);
               this.$refs.ulhot.hotInstance.render();
             // if the district is deleted - clear out the drop down value as well since it won't be valid anymore
              continue;
           }
         if ((this.table === "ultralocal.ul_offices_creation_dropdown") && (change[1] != 'source') || (change[1] == 'source' && (change[3] == null || change[3] == ""))) {
              // for the offices creation dropdown table the only change we want to deal with is the district list.
              continue;
           }
        const rowData = this.$refs.ulhot.hotInstance.getSourceDataAtRow(
          change[0]
        );
        //when the typeahead field changes, update the storage field
        if(change[1] == 'source')
        {
          //console.log("SOURCE CHANGE")
        
          let entity_list = rowData.entity_list;
          
          let found_entity = entity_list.find(o => o.label === change[3]);
         
          let new_entity_id = found_entity._id;
                   
          let columnProp = null;

          if (this.table === "ultralocal.ul_office_matching_dropdown") {
            columnProp = "bp_office_id.id";
          } else if (this.table === "ultralocal.ul_offices_creation_dropdown") {
            columnProp = "office_creation_district.id";
          }

          if (columnProp) {
            
            this.$refs.ulhot.hotInstance.setDataAtCell(
              change[0],
              this.$refs.ulhot.hotInstance.propToCol(columnProp),
              Number(new_entity_id)
            );
          }
          if (this.table === "ultralocal.ul_offices_creation_dropdown") {
             this.$refs.ulhot.hotInstance.render();
             return;
          }
          this.$refs.ulhot.hotInstance.setCellMeta(
                change[0],
                5,
                "valueToRender",
                change[3]);
          this.$refs.ulhot.hotInstance.render();
        }
        // const columnMetaData = this.$refs.ulhot.hotInstance.getCellMeta(
        //   change[0],
        //   this.$refs.ulhot.hotInstance.propToCol(change[1])
        // ).__proto__;
        
        //let dataType = columnMetaData.dataType;
        let id = Number(rowData.id); // Get row ID and convert to number
        let columnName = change[1]; // Get column name of changed value

        if (columnName.includes(".id")) {
          columnName = columnName.substring(0, columnName.length - 3); // this means we are dealing with a related table.  We just want the related table name without the id
        }

        let currentValue = change[2]; // Value of cell before change
        
        let changeCol = this.$refs.ulhot.hotInstance.propToCol(change[1]);
        this.clearErrorValue(change[0],changeCol)
        let updatedValue = this.formatUpdatedValue(change[3]);

        if (currentValue === change[3] || currentValue === updatedValue) {
          // no change so no need for a database call
          continue;
        } else {
          if (isNaN(Number(updatedValue))) {
            // adds leave here.
            
            continue;
          }
          {
            // auto fill out ballotpedia URL for volunteer candidates based on their name

            // similar logic as in people table add for filling out full person name and Metabase URL automatically

            //  Create the payload
            let dataObject = {};

            // custom workflow --> check if we need to update another table
            // normal table
            dataObject.id = id;
            dataObject[columnName] = updatedValue;
            payload = {
              data: [dataObject],
              table: this.table_update,
            };
          }

          // If no frontend errors, hit API, update DB
          let sentence;
          let response = await this.submitPayload(payload);
          if (response.status == 403) {
            response = await response.json();
            alert(response.message);
            window.location.href = "/login";
          } else {
            response = await response.json();
            if (response.success === false) {
              this.updateErrorValue(
                this.$refs.ulhot.hotInstance.toVisualRow(change[0]),
                changeCol,
                JSON.parse(response.message).message
              );
              continue;
            } else {
              // custom workflows: display table and ID that was updated

              //this.showChangeNotification(id, columnName, currentValue, updatedValue);
              sentence = `<b>${id}:</b> <i>${columnName}</i> changed to ${updatedValue}`;
            }
            this.$toastr.s(sentence);

            console.log("Database updated");
          }
        }
      }
    },
    doBeforeKeyDown(event) {
      let selected = this.$refs.ulhot.hotInstance.getSelected();
      
      let coords = {
        row: selected[0][0],
        col: selected[0][1],
      };

      if (event.key === "Delete" || event.key === "Backspace") {
        // if delete or backspace for a related table we want to loop trough all of them and delete the valueToRender
        for (let i = selected[0][0]; i <= selected[0][2]; i++) {
          for (let j = selected[0][1]; j <= selected[0][3]; j++) {
            this.$refs.ulhot.hotInstance.setCellMeta(
              i,
              j,
              "valueToRender",
              null
            );
            //this.$refs.hot.hotInstance.render();
          }
        }
        this.$refs.ulhot.hotInstance.render();
        return;
      } else 
      if (
        this.$refs.ulhot.hotInstance
          .getCellMeta(coords.row, coords.col)
          .prop.includes(".id")
      ) {
        if (!event.ctrlKey) {
          event.stopImmediatePropagation();
          return;
        }
      }
    },
    formatUpdatedValue(updatedValue, dataType) {
      if (
        (dataType === "integer" && updatedValue != null) ||
        (dataType === "numeric" && updatedValue != null)
      ) {
        updatedValue = updatedValue.toString().replace(/,/g, "");
      }
      if (typeof updatedValue === "string") {
        updatedValue = updatedValue.trim(); // Value of cell after change
        updatedValue = updatedValue.length === 0 ? null : updatedValue;
      }

      if (dataType === "ARRAY" && updatedValue) {
        updatedValue = `{${updatedValue}}`;
      }

      if (
        updatedValue === "true" ||
        updatedValue === "false" ||
        (!isNaN(updatedValue) &&
          updatedValue != null &&
          updatedValue.length > 0 &&
          dataType !== "character varying" &&
          dataType !== "text")
      ) {
        updatedValue = JSON.parse(updatedValue);
      }
      updatedValue = updatedValue == null ? null : updatedValue;
      return updatedValue;
    },

    getColumnNumber: (colIn) => {
      let changeFieldColumn;
      if (colIn.includes(".id")) {
        //indicates that we are working with a related table field - so we need to find the field we are renedering
        const rowMeta = this.$refs.ulhot.hotInstance.getCellMetaAtRow(0);

        changeFieldColumn = rowMeta.filter((obj) => {
          return (
            obj.__proto__.colToUpdate === colIn.substring(0, colIn.length - 3)
          );
        });
        changeFieldColumn = changeFieldColumn[0].col;
      } else {
        changeFieldColumn = this.$refs.ulhot.hotInstance.propToCol(colIn);
      }
      return changeFieldColumn;
    },
    async submitPayload(payload) {
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "PATCH",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      return response;
    },
    updateParentSelect(row, select) {
      
      for (let j = row; j >= 0; j--) {
        
        if (this.$refs.ulhot.hotInstance.getDataAtCell(j, 1) != null) {
          this.$refs.ulhot.hotInstance.setDataAtCell(
            j,
            this.$refs.ulhot.hotInstance.propToCol("Select"),
            select
          );
          break;
        }
      }
    },
    validateSelection(row) {
     
      // only one child record can be selected per parent
      let thisParent;

      for (let j = row; j >= 0; j--) {
        if (
          this.$refs.ulhot.hotInstance.getDataAtCell(
            j,
            this.$refs.ulhot.hotInstance.propToCol("contest")
          ) != null
        ) {
          thisParent = j;
          break;
        }
      }
       
      let k = thisParent + 1;
      
      while (
        this.$refs.ulhot.hotInstance.getDataAtCell(
          k,
          this.$refs.ulhot.hotInstance.propToCol("contest")
        ) == null && k <= this.$refs.ulhot.hotInstance
              .getPlugin('AutoRowSize').getLastVisibleRow() 
      ) {
        if (
          k != row &&
          this.$refs.ulhot.hotInstance.getDataAtCell(
            k,
            this.$refs.ulhot.hotInstance.propToCol("Select")
          ) == true
        ) {
          return false;
        }
        k++;
      }
      return true;
    },

    doFormatUrl2() {
      //console.log("is this needed");
    },
    doFormatUrl() {
      const query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy
        ? `${this.orderBy} ${this.sortDirection}`
        : null;
      query.workflow = this.workflow ? this.workflow : null;

      let filterUrl;
      if (this.query === null) {
        filterUrl = `${window.location.href.split("?")[0]}`;
      } else {
        filterUrl = `${window.location.href.split("?")[0]}?${encodeURIComponent(
          JSON.stringify(query)
        )}`;
      }

      let textArea = document.createElement("textarea");
      textArea.value = filterUrl;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        window.alert("Sharable URL copied to clipboard");
      } catch (err) {
        //empty
      }
      document.body.removeChild(textArea);
    },
    collapseAll() {
      this.collapseRows();
    },
    changePage() {
      this.offset = event.target.value;
      this.getFilteredData();
    },
    changePage2() {
      this.offset2 = event.target.value;

      this.getFilteredData2();
    },
    doSearch() {
      this.showSearch = false; // Hide search after click
      this.getFilteredData();
    },
    doSearch2() {
      this.showSearch2 = false; // Hide search after click
      this.getFilteredData2();
    },
    changeLimit() {
      this.limit = event.target.value;
      this.getFilteredData();
    },
    changeLimit2() {
      this.limit2 = event.target.value;
      this.getFilteredData2();
    },
    depthLevel() {
      this.depth = this.depth === 3 ? 1 : 3;
    },
    depthLevel2() {
      this.depth2 = this.depth2 === 3 ? 1 : 3;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    toggleSearch2() {
      this.showSearch2 = !this.showSearch2;
    },
    toggleExpand() {
      this.showExpand = !this.showExpand;
    },
    setOrderBy() {
      this.orderBy = event.target.value;
      this.getFilteredData();
    },
    setOrderBy2() {
      this.orderBy2 = event.target.value;
      this.getFilteredData2();
    },
    setSortDirection() {
      this.sortDirection = event.target.value;
      this.getFilteredData();
    },
    setSortDirection2() {
      this.sortDirection2 = event.target.value;
      this.getFilteredData2();
    },
    async createOffices() {
      const message = ('An office will be created for each row with an office name, district, and branch.  Please confirm that you want to create these offices.')
      if (confirm(message)) {
           
      this.submitCreateClicked = true;

      if (this.workingOnSubmittedData) {
        return;
      }
      this.workingOnSubmittedData = true;
      this.loading = true;
    
      let i = -1;
      for await (const item of this.$refs.ulhot.hotInstance.getSourceData()) {
       
       let district_id = null;

      if (
        item.office_creation_district &&
        item.office_creation_district.id !== null &&
        item.office_creation_district.id !== undefined
      ) {
        district_id = item.office_creation_district.id;
      } else if (
        item.district &&
        item.district.id !== null &&
        item.district.id !== undefined
      ) {
        district_id = item.district.id;
      }


        i += 1;
        if (!district_id || item.office_created != null || item.office_name == null || item.branch == null  ) {
          continue;
        }
        this.clearErrorValue(i, 0);
       
        let dataObject = {};
        dataObject["district"] = Number(district_id);
        dataObject["branch"] = item.branch;
        dataObject["type"] = item.type;
        dataObject["name"] = item.office_name;
        dataObject["level"] = item.level;
        dataObject["coverage_level"] = "ultralocal";
        dataObject["number_of_seats"] = 1;
        //console.log('adding record with data object: ' + JSON.stringify(dataObject))
        let response = await this.addRecord(dataObject);

        if (response.success === false) {
          
          this.updateErrorValue(i, 0, response.message);
          continue;
        } else {
          
          let newId = Number(response.data.id);
          this.$refs.ulhot.hotInstance.setDataAtRowProp(
            i,
            "office_created",
            newId
          );
          this.$refs.ulhot.hotInstance.setCellMeta(
            i,
            this.$refs.ulhot.hotInstance.propToCol("office_created"),
            "className",
            "ul_success"
          );
          dataObject = {};
          dataObject["bp_office_id"] = newId;
          dataObject["office_to_be_created"] = false;
          dataObject["id"] = Number(item.id);
          let payload = {
            data: [dataObject],
            table: this.table_update,
          };
          
          response = await this.submitPayload(payload);
           
        }
      }
      this.$refs.ulhot.hotInstance.render();
      this.loading = false;
      this.workingOnSubmittedData = false;
      // first get data from screen
      }
    },
    async addRecord(dataObject) {
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;
      let payload = {
        data: [dataObject],
        table: "offices",
      };
      
      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      response = await response.json();
      return response;
    },
    async getRelatedData(table, ids) {
      
      if (isNaN(Number(ids))) {
        return;
      }

      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud?table=${table}&ids=${ids}`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "GET",
          headers: headers,
          credentials: "include",
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json();
        return response;
      }
    },
    buildStringToRender(response, responseField) {
      responseField = responseField.split(".");
       
      let buildStringToRender = "";
      let stringToRender = "";
      

      for (let i = 0; i < response.data.length; i++) {
        buildStringToRender = response.data[i];
         
        for (let i = 0; i < responseField.length; i++) {
          buildStringToRender = buildStringToRender[responseField[i]];
           
        }
        stringToRender += `${buildStringToRender},`;
      }
      return stringToRender;
    },
    
  },

  mounted: async function () {
    
    if (window.location.href.indexOf("bfed_batch") > -1) {
       this.batch_id  = JSON.parse(
          JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
        );
          this.batch_id = this.batch_id.replace('bfed_batch_id=', '');
    } 
    if (this.table != "ultralocal.ul_office_matching_selection" && this.table != 'ultralocal.ul_office_matching_dropdown' && this.table != 'ultralocal.ul_offices_creation_dropdown') {
      let table2 =
        this.table == "ultralocal.ul_office_matching"
          ? "ultralocal.offices_for_matching"
          : "ultralocal.districts_for_matching";
      this.columnMetaData = [];
      this.columnMetaData2 = [];
      this.table_hold = this.table;
      this.table = table2;
      await this.generateColumnMetaData("Edit", table2);
      this.columnMetaData2 = [...this.columnMetaData];
      this.columnMetaData = [];
      this.table = this.table_hold;
      await this.generateColumnMetaData("Edit", this.table);
      
    } else if (this.table == 'ultralocal.ul_office_matching_dropdown' || this.table == 'ultralocal.ul_offices_creation_dropdown'){
      this.columnMetaData = [];
      await this.generateColumnMetaData("Edit", this.table)
    }
     
    this.rules = await this.generateFiltersForSearch();

    if (this.table == "ultralocal.ul_office_matching") {
      this.table = "ultralocal.offices_for_matching";
      this.rules2 = await this.generateFiltersForSearch();
      this.table = "ultralocal.ul_office_matching";
    }
    if (this.table == "ultralocal.ul_offices_creation_workflow") {
      this.table = "ultralocal.districts_for_matching";
      this.rules2 = await this.generateFiltersForSearch();
      this.table = "ultralocal.ul_offices_creation_workflow";
    }
    this.orderByFilters = await this.getOrderByFilters(this.rules);
     
    await this.refreshHoTData();
   
    if (
      this.table == "ultralocal.ul_office_matching" ||
      this.table == "ultralocal.ul_offices_creation_workflow"
    ) {
      this.orderByFilters2 = await this.getOrderByFilters(this.rules2);
      await this.getFilteredData2();
       
    }
    this.pageDisclaimer = await this.getPageDisclaimer(
      this.table.replace("ultralocal.", "")
    );
    this.$nextTick(() => {
    if (this.table === 'ultralocal.ul_office_matching_dropdown' || this.table === 'ultralocal.ul_offices_creation_dropdown') { 
      this.dataListCol = this.$refs.ulhot.hotInstance.propToCol('entity_list'); 
      this.sourceCol = this.$refs.ulhot.hotInstance.propToCol('source')
      
    }
  });
        
  },
};
Handsontable.renderers.registerRenderer(
  "relatedTableRenderer",
  function (hotInstance, td, row, column, prop, value, cellProperties) {
    
    let cellMeta = hotInstance.getCellMeta(row, column);
    let valToRender;
    if (cellProperties.valid === false) {
      td.className = "htInvalid";
    }
    if (cellProperties.readOnly === true) {
      td.className = "htDimmed";
    }
    if (cellMeta.valueToRender === null || cellMeta.valueToRender) {
      valToRender = cellMeta.valueToRender;
    } else {
      valToRender = hotInstance.getDataAtRowProp(
        row,
        cellMeta.__proto__.colToRender
      );
    }

    if (valToRender !== null && typeof valToRender != "object") {
      td.innerHTML = valToRender;
    } else {
      td.innerHTML = value == null ? "" : value;
    }
    
    return td;
  }
);
</script>
<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.orderBy,
.sortBy {
  width: 120px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.frozenSelect {
  width: 70px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.workflow {
  width: 160px;
}

.search-options label {
  font-size: 12px;
}

.search-options .form-control {
  height: 30px;
}

.btn {
  margin-top: 30px;
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.checkbox {
  margin-top: 0px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
  margin-bottom: 10%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
.badge-error {
  background-color: red;
  color: white;
}
.edit-add {
  color: #337ab7;
}
</style>
 <style>
.ulhandsontable {
  margin-left: -5px;
  margin-bottom: 20px;
}
.ulhandsontable_small {
  width: 90%;
  height: 800px;
  overflow: hidden;
}
.ulhandsontable .ht_nestingParent,
.ulhandsontable .ht_nestingParent ~ td {
  background: #073980;
  color: #fff;
  font-weight: lighter !important;
  font-style: normal !important;
}

.ulhandsontable .ht_nestingLevels ~ td {
  font-weight: bolder;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-bottom: 1px;
}

.offices_for_matching {
  display: block;
  float: right;
  width: 48%;
  font-size: 0.85em;
 }
.districts_for_matching {
  display: block;
  float: right;
  width: 38%;
  font-size: 0.85em;
}
.ul_office_matching {
  float: left;
  width: 52%;
  font-size: 0.85em;
  
}
.ul_offices_creation_workflow {
  float: left;
  width: 60%;
  font-size: 0.85em;
   
}
.ul_success  {
  background: #cff8a5 !important;
}
</style>